// extracted by mini-css-extract-plugin
export default {"typing":"ScrollableChat_typing__2DpZu","dot":"ScrollableChat_dot__oIdDJ","mercuryTypingAnimation":"ScrollableChat_mercuryTypingAnimation__b0kCM"};